import React from 'react';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
import classes from './profilePassword.scss';
import SceTextBoxComponent from '../../Common/profileText';
import SceButton from '../../../Common/CommonComponents/sceButton';
import LoginPopup from './loginPopup';  
import loginHoc from '../../../Login/loginHoc';

class ProfilePasswordCard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            editBtnClicked: false,
            oldPassword: { value: '', isError: false, isValidated: false, forceValidate: false, errorMessage: '' },
            newPassword: { value: '', isError: false, isValidated: false, forceValidate: false, errorMessage: '' },
            confirmPassword: { value: '', isError: false, isValidated: false, forceValidate: false, errorMessage: '' },
            resetText: false, showSaveError: false, showLoginPopUp: false,
        };
        this.strings = getLocalizedStrings('GeneralSettings');
      }

    editBtnClickHandler = () => {
        window.aUtils.sendAAEvent("button","passwordEdit");
        this.setState({ editBtnClicked: true });
    }

    retrieveInputData = (data) => {
        let inputDataState = { ...this.state };
        if (data.id === 'newPassword' || data.id === 'confirmPassword') {
            if (data.id === 'newPassword' && inputDataState.confirmPassword.isValidated) {
                if (data.value !== inputDataState.confirmPassword.value) {
                inputDataState.confirmPassword.isError = true;
                inputDataState.confirmPassword.isValid = false;
                } else {
                inputDataState.confirmPassword.isValid = true;
                inputDataState.confirmPassword.isError = false; 
              }}  
        }
        if (data.id === 'oldPassword' && inputDataState.newPassword.isValidated) {
          if (data.value === inputDataState.newPassword.value) {
            inputDataState.newPassword.isError = true, inputDataState.newPassword.isValid = false;
            inputDataState.newPassword.errorMessage = this.strings.newPasswordErrorMessage;
          } else {
            inputDataState.newPassword.isValid = true, inputDataState.newPassword.isError = false;
            inputDataState.newPassword.errorMessage = ''; }
        }
        inputDataState[data.id] = { ...inputDataState[data.id], ...data };
        inputDataState[data.id]['forceValidate'] = false;
        this.setState(inputDataState);
    }

    onSavePasswordHandler = () => {
        window.aUtils.sendAAEvent("button","editPasswordSave");
        let updatedState = { ...this.state };
        if(updatedState.oldPassword.isValidated && updatedState.newPassword.isValidated && updatedState.confirmPassword.isValidated){
            if (!updatedState.oldPassword.isError && !updatedState.newPassword.isError && !updatedState.confirmPassword.isError) {
                let requestParams = {};
                requestParams.emailId = this.props.email;
                requestParams.newPassword = updatedState.newPassword.value;
                requestParams.password = updatedState.oldPassword.value;
                let reqObj = { reqParams: requestParams };
                app.profileSettingsService.updateProfilePassword(reqObj).then((response) => {
                    if(response.update === 'success'){
                        this.onPwdChangeLogOut();
                    }
                  
                },(error) => {
                    if(error.errorCode === 'INVALIDCREDENTIALS'){
                        updatedState.oldPassword.isError = true;
                        updatedState.showSaveError = false;
                        this.setState({ ...updatedState });
                    }else{
                        updatedState.showSaveError = true;
                        this.setState({ ...updatedState });
                    }
                });
            }
        }else {
            var switchObj = ['oldPassword','newPassword','confirmPassword'];
            for(const element of switchObj){
                updatedState[element]['forceValidate'] = (!updatedState[element]['isValidated'])? true : false;
            }
            this.setState({ ...updatedState });
        }
    }

    cancelBtnHandler = () => {
        let resetObj = { value: '', isError: false, isValidated: false, forceValidate: false, errorMessage: '' };
        let updatedState = { ...this.state };
        updatedState.oldPassword = resetObj;
        updatedState.newPassword = resetObj;
        updatedState.confirmPassword = resetObj;
        updatedState.editBtnClicked = false;
        updatedState.showSaveError = false;
        this.setState({ ...updatedState });
    }
    // Logout user after password change
    onPwdChangeLogOut = () => {
        app.pubSubService.unsubscribe('PubSubSessionExpiry');
        app.identityService.logout().then((response) => {
           this.handleLogOut();   
            }, error => {
            this.handleLogOut();             
          });          
    }
    
    handleLogOut = () => {
         app.identityService.handleUserLogout();
            app.appService.setSessionstorage(app.appService.appConstants.isPwdChanged,true);
            let resetObj = { value: '', isError: false, isValidated: false, forceValidate: false, errorMessage: '' };
            this.setState({ ...this.state, oldPassword:resetObj, newPassword:resetObj, confirmPassword:resetObj,
                           editBtnClicked:false, showSaveError:false, showLoginPopUp:true});
    }

    getViewToShow = () => {
        const LoginComponent = loginHoc(LoginPopup);
        if(this.state.editBtnClicked){
            let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
            let errorView = this.state.showSaveError ? 
                            <div className={classes.passwordErrSec}>
                                <img className={classes.warningIcon} src={warningIcon} alt="Warning Icon" />
                                <p className={classes.warningMsg}>{this.strings.saveError}</p>
                            </div> : null;
            return(
                <div>
                    <div className={classes.passwordLabel}>{this.strings.editPasswordLabel}</div>
                    <div className={classes.passwordPadding}>
                        <div>{this.strings.oldPasswordLabel}</div>
                        <div className={classes.passwordTextBox}>
                            <SceTextBoxComponent
                                type='currentPassword'
                                id='oldPassword'
                                autoComplete='off'
                                forceValidate={this.state.oldPassword.forceValidate}
                                isError={this.state.oldPassword.isError}
                                validator={app.appUtil.validator}
                                onTextUpdatedHandler={this.retrieveInputData}
                            />
                        </div>
                    </div>
                    <div className={classes.passwordPadding}>
                        <div>{this.strings.newPasswordLabel}</div>
                        <div className={classes.passwordTextBox}>
                            <SceTextBoxComponent
                                id='newPassword'
                                type='newPassword'
                                autoComplete='off'
                                forceValidate={this.state.newPassword.forceValidate}
                                validator={app.appUtil.validator}
                                onTextUpdatedHandler={this.retrieveInputData}
                                prevPassword={this.state.oldPassword.value}
                                isError={this.state.newPassword.isError}
                                errorMsg={this.state.newPassword.errorMessage}
                            />
                        </div>
                    </div>
                    <div className={classes.passwordPadding}>
                        <div>{this.strings.verifyPasswordLabel}</div>
                        <div className={classes.passwordTextBox}>
                            <SceTextBoxComponent
                                id='confirmPassword'
                                type='confirmPassword'
                                autoComplete='off'
                                isError={this.state.confirmPassword.isError}
                                forceValidate={this.state.confirmPassword.forceValidate}
                                validator={app.appUtil.validator}
                                prevPassword={this.state.newPassword.value}
                                onTextUpdatedHandler={this.retrieveInputData}
                            />
                        </div>
                    </div>
                    <div className={'row ' + classes.passwordButtons}>
                        <div className={'col-md-6 ' + classes.passwordSaveBtn}>
                            <SceButton
                                id='Save'
                                buttonType='default'
                                value={this.strings.save}
                                onClick={this.onSavePasswordHandler}
                            />
                        </div>
                        <div className={'col-md-6 ' + classes.passwordCancelBtn}>
                            <SceButton
                                id='Cancel'
                                buttonType='default'
                                onClick={this.cancelBtnHandler}
                                value={this.strings.cancel}
                            />
                        </div>
                    </div>
                    {errorView}
                </div>
            );
        } else if(this.state.showLoginPopUp) {
            return(
                <LoginComponent />
            );
        }
        else{
            return(
                <div>
                    <div className={classes.passwordLabel}>{this.strings.passwordLabel}</div>
                    <div className={classes.editButtonPadding}><button className={classes.editButton} id="scePrfSettngspasswordEdit" onClick={this.editBtnClickHandler} >{this.strings.editBtn}</button></div>
                    <div className={classes.passwordContent}>{'********'}</div>
                </div>
            );
        }
    }

    render(){
        let view = this.getViewToShow();
        return(
            <div className={classes.Card}>
                {view}
            </div>
        );
    }
}

export default ProfilePasswordCard;
